<template>
      <section class="counter-wraper pos-rel black-bg pt-120 pb-90" data-overlay="dark" data-opacity="7"> 
        <!--  -->
            <div class="fact-bg slider-bg" :style="{backgroundImage:'url('+ require('../../assets/img/slider/slider3.jpeg')+')'}"></div>
            <div class="container">
                <div class="row justify-content-center">
                    <div v-for="counter in counterData" :key="counter.id" class="col-lg-3 col-md-3">
                        <div class="single-couter counter-box text-center mb-30 z-index">
                            <div class="fact-icon">
                              <i :class="`${counter.icon}`"></i>
                            </div>
                            <h2><span class="counter">{{counter.number}}</span></h2>
                            <h4>{{counter.title}}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </section>
</template>

<script>
export default {
    name:'HomeCounter',
    data () {
        return {
            counterData:[
                {
                    id:'1',
                    icon:'flaticon-group',
                    number:'6852',
                    title:'Anëtarë'
                },
                {
                    id:'2',
                    icon:'flaticon-happiness',
                    number:'6852',
                    title:'Klient të knaqur'
                },
                {
                    id:'3',
                    icon:'flaticon-label',
                    number:'1235',
                    title:'Intervenime me sukses'
                },
            ]
        }
    }
}
</script>